<template>
    <v-layout justify-center wrap id="salesforce">
        <v-flex md6 xs6>
            <SalesforceReexport />
        </v-flex>
    </v-layout>
</template>
<script>
import SalesforceReexport from '@/components/salesforce/SalesforceReexport.vue';

export default {
    name: 'Salesforce',
    components: {
        SalesforceReexport,
    },
};

</script>
<style scoped lang="scss"></style>
